import * as React from 'react';
import {useState} from 'react';
import {IsNotEmpty} from "class-validator";
import {container} from "@intelingu/core/IoC/container";
import {WorkspaceStore} from "../../../../stores/WorkspaceStore";
import {useGetMnemoCardByIdQuery, useUpdateMnemoMutation} from "../../../../types.d";
import {getParam} from "../../../../utils/getParam";
import {Redirect} from "react-router";
import moment from "moment";
import {Form} from "@intelingu/core/components/form/Form";
import {FormGroup} from "../../../partials/form/elements/FormGroup";
import {Field} from "@intelingu/core/components/form/Field";
import {TextArea} from "../../../partials/form/elements/TextArea";
import {SubmitButton} from "../../../partials/form/elements/SubmitButton";
import {FormErrorMessage} from "../../../partials/form/FormErrorMessage";

export class Validator {

    @IsNotEmpty()
    disapproveComment;

}

const initialComment = `keyword:
sentence:
story:`;

export const ReviewMnemoForm = props => {
    const [created, setCreated] = useState<boolean>(false);

    const courseId = container.get(WorkspaceStore).courseId;

    const [ updateMnemo, { data: updatedMnemo } ] = useUpdateMnemoMutation({
        fetchPolicy: 'no-cache'
    });

    const {
        data
    } = useGetMnemoCardByIdQuery({
        fetchPolicy: 'network-only',
        variables: { id: getParam<number>('mnemo_id') }
    });

    if (!data || !data.mnemo) {
        return <h2>Loading...</h2>
    }

    const card = data.mnemo.card;

    if (created) {
        return <Redirect to={`/creation/next/${courseId}/MC`} />
    }

    const date: string = moment().format("YYYY-MM-DD HH:mm:ss");
    const wordTranslation = card.wordTranslation;

    return <Form
        validator={Validator}
        defaultData={{ disapproveComment: initialComment }}
        onSubmit={async (data, done) => {
            let value = JSON.parse(JSON.stringify(data));

            if (data.disapprovedAt) {
                value = {
                    ...value,
                    ...{
                        reviewedAt: ''
                    }
                };
            } else {
                delete value.disapproveComment;

                value = {
                    ...value,
                    ...{
                        reviewedAt: date
                    }
                };
            }

            await updateMnemo({
                variables: {
                    id: getParam<number>('mnemo_id'),
                    input: value
                }
            });

            done();

            setCreated(true);
        }}
    >
        <div className="row px-3">
            <div className="col-4">
                <label><strong>Vocabulary</strong>:</label>
                <span className="mx-1">{ wordTranslation.sourceWord.lemma }</span>
            </div>
            <div className="col-8">
                <label><strong>Translation</strong>:</label>
                <span className="mx-1">{ wordTranslation.translationWord.lemma }</span>
            </div>
        </div>

        <div className="row px-3">
            <div className="col-12">
                <label><strong>Keyword</strong>:</label>
                <span className="mx-1">{ data.mnemo.mnemoKeyword }</span>
            </div>
        </div>

        <div className="row px-3">
            <div className="col-12">
                <label><strong>Short sentence</strong>:</label>
                <span className="mx-1" dangerouslySetInnerHTML={{ __html: data.mnemo.shortSentence }} />
            </div>
        </div>

        <div className="row px-3">
            <div className="col-12">
                <label><strong>Sentence</strong>:</label>
                <span className="mx-1" dangerouslySetInnerHTML={{ __html: data.mnemo.sentence}} />
            </div>
        </div>

        <div className="row px-3">
            <div className="col-12">
                <label><strong>Translation Audio</strong>:</label>
                <span className="mx-1">
                    <audio controls={true} src={wordTranslation.audio} />
                </span>
            </div>
        </div>

        <FormGroup
            className={'mt-5'}
            label={'Comment'}
            required={true}
        >
            <Field
                name={'disapproveComment'}
                render={props => (
                    <TextArea
                        autoResize={true}
                        {...props} />
                )} />
        </FormGroup>

        <div className={'col-12'}>
            <FormErrorMessage />
            <Field
                name={'disapprovedAt'}
                submit
                render={props => <SubmitButton value={date} colorType={'danger'} {...props}>Disapprove</SubmitButton>} />&nbsp;
            <Field
                name={'approvedAt'}
                submit
                render={props => <SubmitButton value={date} {...props}>Approve</SubmitButton>} />
        </div>
    </Form>
};

export const ReviewMnemo = props => (
    <div className={'index-wrapper'}>
        <div className={'index-page'}>
            <div className="ig-form-heading">
                <h1 className="form-primary-title">REVIEW OF MNEMO CARD</h1>
            </div>

            <ReviewMnemoForm />
        </div>
    </div>
);
